import { all, fork, put, takeEvery, call, takeLatest } from 'redux-saga/effects';
import { UnitActionTypes } from './constants';

import { unit, createUnit, updateUnit, deleteUnit, uploadUnit } from './api';
/**
 * Login the user
 * @param {*} payload - username and password
 */


function* unitDataGetFunction(data) {
    try {
        yield put({
            type: UnitActionTypes.UNIT_DATA_LOADING,
            payload: {},
        });
        const response = yield call(unit, data);
        if (response.data.status) {
            yield put({
                type: UnitActionTypes.UNIT_DATA_SUCCESS,
                payload: { ...response.data },
            });
        } else {
            yield put({
                type: UnitActionTypes.UNIT_DATA_ERROR,
                payload: { ...response.data },
            });
        }
    } catch (error) {
        yield put({
            type: UnitActionTypes.UNIT_DATA_ERROR,
            payload: error,
        });
    }
}

function* unitDataCreateFunction(data) {
    try {
        yield put({
            type: UnitActionTypes.CREATE_UNIT_DATA_LOADING,
            payload: {},
        });
        const response = yield call(createUnit, data);
        if (response.data.status) {
            yield put({
                type: UnitActionTypes.CREATE_UNIT_DATA_SUCCESS,
                payload: { ...response.data },
            });
        } else {
            yield put({
                type: UnitActionTypes.CREATE_UNIT_DATA_ERROR,
                payload: { ...response.data },
            });
        }
    } catch (error) {
        yield put({
            type: UnitActionTypes.CREATE_UNIT_DATA_ERROR,
            payload: error,
        });
    }
}

function* unitDataUploadFunction(data) {
    try {
        yield put({
            type: UnitActionTypes.UPLOAD_UNIT_DATA_LOADING,
            payload: {},
        });
        const response = yield call(uploadUnit, data);
        if (response.data.status) {
            yield put({
                type: UnitActionTypes.UPLOAD_UNIT_DATA_SUCCESS,
                payload: { ...response.data },
            });
        } else {
            yield put({
                type: UnitActionTypes.UPLOAD_UNIT_DATA_ERROR,
                payload: { ...response.data },
            });
        }
    } catch (error) {
        yield put({
            type: UnitActionTypes.UPLOAD_UNIT_DATA_ERROR,
            payload: error,
        });
    }
}

function* unitDataUpdateFunction(payload) {
    try {
        yield put({
            type: UnitActionTypes.UPDATE_UNIT_DATA_LOADING,
        });

        const response = yield call(updateUnit, payload);


        if (response && response.data && response.data.status === 'success') {
            yield put({
                type: UnitActionTypes.UPDATE_UNIT_DATA_SUCCESS,
                payload: response.data,
            });
        } else {
            yield put({
                type: UnitActionTypes.UPDATE_UNIT_DATA_ERROR,
                payload: response.data,
            });
        }
    } catch (error) {
        yield put({
            type: UnitActionTypes.UPDATE_UNIT_DATA_ERROR,
            payload: { message: error.message },
        });
    }
}

function* unitDataDeleteFunction(payload) {
    try {
        yield put({
            type: UnitActionTypes.DELETE_UNIT_DATA_LOADING,
        });

        const response = yield call(deleteUnit, payload);


        if (response && response.data && response.data.status) {
            yield put({
                type: UnitActionTypes.DELETE_UNIT_DATA_SUCCESS,
                payload: response.data,
            });
        } else {
            yield put({
                type: UnitActionTypes.DELETE_UNIT_DATA_ERROR,
                payload: response.data,
            });
        }
    } catch (error) {
        yield put({
            type: UnitActionTypes.DELETE_UNIT_DATA_ERROR,
            payload: { message: error.message },
        });
    }
}

export function* watchUnitDataGet() {
    yield takeLatest(UnitActionTypes.UNIT_DATA_FIRST, unitDataGetFunction);
}
export function* watchUnitDataCreate() {
    yield takeEvery(UnitActionTypes.CREATE_UNIT_DATA_FIRST, unitDataCreateFunction);
    yield takeEvery(UnitActionTypes.UPLOAD_UNIT_DATA_FIRST, unitDataUploadFunction);
}
export function* watchUnitDataUpdate() {
    yield takeLatest(UnitActionTypes.UPDATE_UNIT_DATA_FIRST, unitDataUpdateFunction);
}
export function* watchUnitDataDelete() {
    yield takeEvery(UnitActionTypes.DELETE_UNIT_DATA_FIRST, unitDataDeleteFunction);
}


function* unitSaga() {
    yield all([
        fork(watchUnitDataGet),
        fork(watchUnitDataCreate),
        fork(watchUnitDataUpdate),
        fork(watchUnitDataDelete),
    ]);
}
export default unitSaga;